import { brochureMapping } from "Constants/courses";


export const downloadBrochure = (courseId, courseName, showModalCallback) => {
    const brochureUrl = brochureMapping[courseId];
    
    if (brochureUrl) {
      // Open PDF in new tab
      window.open(brochureUrl, '_blank', 'noopener,noreferrer');
    } else {
      // Call the callback to show modal
      if (showModalCallback) {
        showModalCallback(courseName);
      }
    }
  };